import { updateTare } from 'api/harvest'
import { FormControlLabel, TextField } from '@mui/material'
import { closeModal } from 'actions/app'
import ModalTool from 'components/modal/modal-tool'

export default function ChangeTare() {
  const [tare, setTare] = useState()
  const [calibration, setCalibration] = useState()
  const [equipmentChoice, setEquipment] = useState()

  const harvest = useSelector((state) => state.harvest.current)

  const dispatch = useDispatch()

  const { t } = useTranslation()

  const closePopup = useCallback(() => {
    dispatch(closeModal())
  })
  const onChangeTare = useCallback((e) => {
    setTare(e.target.value)
  }, [])
  const onChangeCalibration = useCallback((e) => {
    setCalibration(e.target.value)
  }, [])

  let harvesterInfo = harvest?.stats?.harvester_info

  const hardware = useSelector((state) => state.hardware.collection)
  const equipment = useSelector((state) => state.equipment.collection)

  let equipmentArray = useMemo(() => {
    let _equipmentArray = []
    if (hardware && equipment && harvesterInfo) {
      for (let harvester in harvesterInfo) {
        const h = harvesterInfo[harvester]
        //if harvesterInfo has a ymId use it, if it doesn't then try to use whatever harvester info is indexed by.
        const ymId = h?.ymId || harvester
        let hwObj = hardware.find((hw) => hw?.farmtrxHardwareId === ymId)
        let eqObj =
          hwObj && equipment.find((eq) => eq.id === hwObj?.equipmentId)
        _equipmentArray.push({
          name: eqObj ? eqObj.nickname : ymId,
          ymId: ymId,
        })
      }
    }
    return _equipmentArray
  }, [hardware, equipment, harvesterInfo])

  // Derived rather than assigned during render: falling back to the first
  // entry keeps the shown value and the submitted value in agreement.
  const selectedEquipment = equipmentChoice ?? equipmentArray[0]?.ymId

  const onAChangeTare = useCallback(() => {
    dispatch(
      updateTare(
        harvest.id,
        parseFloat(tare),
        parseFloat(calibration),
        selectedEquipment,
        harvest.tenantId,
      ),
    )
  }, [harvest, tare, calibration, selectedEquipment])

  const onChangeEquipment = useCallback((e) => {
    setEquipment(e.target.value)
  }, [])

  const applyDisabled =
    selectedEquipment == null ||
    tare == null ||
    calibration == null ||
    tare == '' ||
    calibration == ''

  return (
    <ModalTool
      header={t('edit_sensor_calibration')}
      content={
        <>
          <FormControlLabel
            control={
              <TextField
                id="select-equipment"
                sx={{ width: '25ch', padding: '10px' }}
                disabled={!equipmentArray.length > 1}
                select
                name="equipment"
                value={selectedEquipment}
                onChange={onChangeEquipment}
                slotProps={{ select: { native: true } }}
                variant="outlined"
                size="small"
                placeholder={t('select_equipment')}
              >
                {equipmentArray.map((equipment) => (
                  <option value={equipment.ymId} key={equipment.ymId}>
                    {equipment.name}
                  </option>
                ))}
              </TextField>
            }
            label={t('equipment')}
            labelPlacement="start"
          />
          <FormControlLabel
            control={
              <TextField
                id="editTareHz"
                sx={{ width: '25ch', padding: '10px' }}
                defaultValue={tare}
                name="edit_tare"
                variant="outlined"
                size="small"
                onChange={onChangeTare}
              />
            }
            label={t('edit_tare')}
            labelPlacement="start"
          />
          <FormControlLabel
            control={
              <TextField
                id="editTare"
                sx={{ width: '25ch', padding: '10px' }}
                defaultValue={calibration}
                name="editTare"
                variant="outlined"
                size="small"
                onChange={onChangeCalibration}
              />
            }
            label={t('edit_tare_percent')}
            labelPlacement="start"
          />
        </>
      }
      onClose={closePopup}
      onApply={onAChangeTare}
      disabled={applyDisabled}
    />
  )
}
